export default __webpack_public_path__ + "static/media/201.cf0278cb.jpg";